<!-- 增改模板 -->
<template>
  <div>
    <el-dialog
      width="1063px"
      :title="detailId ? '编辑商品模板' : '新增商品模板'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <!-- 模板-商品类目 -->
        <div class="mu-ban-category">
          <div>
            <span class="m-r-4 c-red">*</span>
            <span class="m-r-5 c-black">商品类目</span>
          </div>
          <b-goods-texture
            v-if="loaded"
            :data.sync="categoryTextureData"
            :bao_han="bao_han"
            :categoryTextureStr="categoryTextureStr"
            width="951px"
          />
        </div>
        <!-- 模板-基础信息 -->
        <e-form
          ref="refForm"
          :column="formColumn"
          :data.sync="selfData"
          :rules="rules"
          :disabled="disabled"
        />
        <!-- 模板-模块 -->
        <div class="module-box">
          <TabsMoKuai
            :list="tabNavList"
            :index.sync="activeNavIndex"
            :disabled="disabled"
            @do="moduleDoOpen"
            @delete="moduleDelete"
          />
          <div class="module-cont">
            <!-- 第二层 表单 -->
            <div class="form-list">
              <div
                class="form-item"
                v-for="(itemNd, indexNd) in selfData.custom_mo_kuai_list[activeNavIndex].list"
                :key="indexNd"
              >
                <div class="form-top">
                  <div class="form-left">
                    <div class="form-name">{{ itemNd.name }}</div>
                    <el-link
                      v-if="itemNd.is_set && itemNd.list.length && !disabled"
                      type="success"
                      @click="ziDuanDoOpen(indexNd)"
                    >
                      维护字段
                    </el-link>
                    <el-link v-if="itemNd.is_edit" type="primary" @click="formDoOpen(indexNd)">
                      编辑
                    </el-link>
                    <el-link v-if="itemNd.is_edit" type="danger" @click="formDelete(indexNd)">
                      删除
                    </el-link>
                  </div>
                </div>
                <!-- 第三层 字段 -->
                <div class="zi-duan-list" v-if="itemNd.is_show">
                  <div
                    class="zi-duan-group"
                    v-show="isShowField(itemRd)"
                    v-for="(itemRd, indexRd) in itemNd.list"
                    :key="indexRd"
                  >
                    <div
                      :class="{
                        'zi-duan-item': true,
                        'is-set': itemRd.is_set
                      }"
                    >
                      <div class="zi-duan-name">
                        <!-- 分隔 || 下拉框 || 公式 -->
                        <div
                          v-if="
                            itemRd.lei_xing_id === 4 ||
                            itemRd.lei_xing_id === 8 ||
                            itemRd.lei_xing_id === 11
                          "
                          class="flex flex-1 flex-y-center flex-x-between"
                          :class="addClassQuestion(itemRd)"
                          @click="ziDuanSet(indexNd, indexRd)"
                        >
                          <div class="flex flex-y-center">
                            <span>{{ itemRd.name }}</span>
                            <span class="vxe-icon-question-circle question-box">
                              <!-- 分隔 -->
                              <span class="question-cont" v-if="itemRd.lei_xing_id === 4">
                                {{ $tool.useEnSymbolFenGe(itemRd.set_symbol) }}
                              </span>
                              <!-- 下拉框 -->
                              <span class="question-cont" v-if="itemRd.lei_xing_id === 8">
                                {{
                                  itemRd.set_options.length
                                    ? `已设置${itemRd.set_options.length}个下拉数据`
                                    : '请设置下拉数据'
                                }}
                              </span>
                              <!-- 公式 -->
                              <span class="question-cont" v-if="itemRd.lei_xing_id === 11">
                                {{
                                  itemRd.set_gong_shi.length
                                    ? `${itemRd.name}=${itemRd.set_gong_shi.join('')}`
                                    : '请设置公式'
                                }}
                              </span>
                            </span>
                          </div>
                          <i v-if="itemRd.is_set" class="m-l-5 vxe-icon-setting" />
                        </div>
                        <!-- 其他 -->
                        <span v-else>{{ itemRd.name }}</span>
                      </div>
                    </div>
                    <div class="zi-duan-item c-gray-c">{{ itemRd.lei_xing_str }}</div>
                  </div>
                  <div v-if="itemNd.list.length" class="p-5"></div>
                  <div
                    v-if="activeNavIndex && itemNd.is_set && !itemNd.list.length && !disabled"
                    class="flex flex-y-center m-l-5"
                  >
                    <el-link type="success" @click="ziDuanDoOpen(indexNd)"> 维护字段 </el-link>
                  </div>
                </div>
              </div>
              <template v-if="!activeNavIndex">
                <div
                  class="form-item"
                  v-for="(itemNd, indexNd) in selfData.default_mo_kuai_list"
                  :key="`default-${indexNd}`"
                >
                  <div class="form-top">
                    <div class="form-left">
                      <div class="form-name">{{ itemNd.name }}</div>
                    </div>
                  </div>
                  <!-- 第三层 字段 -->
                  <div class="zi-duan-list">
                    <div
                      class="zi-duan-group"
                      v-for="(itemRd, indexRd) in itemNd.list"
                      :key="indexRd"
                    >
                      <div class="zi-duan-item">
                        <span class="zi-duan-name">{{ itemRd.name }}</span>
                      </div>
                      <div class="zi-duan-item c-gray-c"></div>
                    </div>
                    <div v-if="itemNd.list.length" class="p-5"></div>
                  </div>
                </div>
              </template>
              <el-button
                v-else
                :class="{
                  'form-add': true,
                  'm-t-10': selfData.custom_mo_kuai_list[activeNavIndex].list.length
                }"
                type="success"
                size="mini"
                @click="formDoOpen"
              >
                ＋新增表单
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="flex flex-y-center flex-x-between">
          <div>
            <template v-if="!detailId">
              <span class="c-gray">快速引用：</span>
              <el-select
                size="mini"
                v-model="muBanChooseId"
                placeholder="选择模板引用数据"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in muBanChooseList"
                  :key="index"
                  :label="item.key"
                  :value="item.val"
                />
              </el-select>
              <el-button
                v-if="activeCategoryType === '原料'"
                class="m-l-10"
                style="opacity: 0"
                title="一键引用"
                size="mini"
                @click="oneKeyLoadData"
              >
                一键引用
              </el-button>
            </template>
          </div>
          <div class="m-r-10">
            <el-button size="mini" @click="popupCancel">
              {{ disabled ? '关闭' : '取消' }}
            </el-button>
            <el-button v-if="!disabled" size="mini" type="primary" @click="popupConfirm">
              保存
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 弹窗-增改模块 -->
    <PopupDoMoKuai
      v-if="isShowPopupDoMoKuai"
      :show.sync="isShowPopupDoMoKuai"
      :index="activeMoKuaiIndex"
      :list="selfData.custom_mo_kuai_list"
      @success="moduleDoSuccess"
    />

    <!-- 弹窗-增改表单 -->
    <PopupDoForm
      v-if="isShowPopupDoForm"
      :show.sync="isShowPopupDoForm"
      :index="activeFormIndex"
      :list="selfData.custom_mo_kuai_list[activeNavIndex].list"
      @success="formDoSuccess"
    />

    <!-- 弹窗-增改字段 -->
    <PopupDoZiDuan
      v-if="isShowPopupDoZiDuan"
      :show.sync="isShowPopupDoZiDuan"
      :index="activeFormIndex"
      :list="selfData.custom_mo_kuai_list[activeNavIndex].list"
      @success="ziDuanDoSuccess"
    />

    <!-- 弹窗-设置规格 -->
    <PopupSetSpec
      v-if="isShowPopupSetSpec"
      :show.sync="isShowPopupSetSpec"
      :gui_ge_list.sync="selfData.gui_ge_list"
      :can_shu_tu_pian.sync="selfData.can_shu_tu_pian"
      :fu_jia_can_shu_list.sync="selfData.fu_jia_can_shu_list"
      :disabled="!!selfData.id"
    />

    <!-- 弹窗-设置单位 -->
    <PopupSetUnit v-if="isShowPopupSetUnit" :show.sync="isShowPopupSetUnit" :data.sync="selfData" />

    <!-- 弹窗-设置价格 -->
    <PopupSetPrice
      v-if="isShowPopupSetPrice"
      :show.sync="isShowPopupSetPrice"
      :list="[selfData]"
      type="价格"
      @success="setPriceSuccess"
    />

    <!-- 弹窗-绑定设备 -->
    <PopupBindSheBei
      v-if="isShowPopupBindSheBei"
      :show.sync="isShowPopupBindSheBei"
      :list.sync="selfData.she_bei_list"
    />

    <!-- 弹窗-设置分隔符号 -->
    <PopupSetSymbol
      v-if="isShowPopupSetSymbol"
      :show.sync="isShowPopupSetSymbol"
      :data.sync="
        selfData.custom_mo_kuai_list[activeNavIndex].list[activeFormIndex].list[activeZiDuanIndex]
      "
    />

    <!-- 弹窗-设置下拉数据 -->
    <PopupSetOptions
      v-if="isShowPopupSetOptions"
      :show.sync="isShowPopupSetOptions"
      :data.sync="
        selfData.custom_mo_kuai_list[activeNavIndex].list[activeFormIndex].list[activeZiDuanIndex]
      "
    />

    <!-- 弹窗-设置公式 -->
    <PopupSetGongShi
      v-if="isShowPopupSetGongShi"
      :show.sync="isShowPopupSetGongShi"
      :data="selfData"
      :name="
        selfData.custom_mo_kuai_list[activeNavIndex].list[activeFormIndex].list[activeZiDuanIndex]
          .name
      "
      :list.sync="
        selfData.custom_mo_kuai_list[activeNavIndex].list[activeFormIndex].list[activeZiDuanIndex]
          .set_gong_shi
      "
    />
  </div>
</template>

<script>
import TabsMoKuai from './tabs-mo-kuai'
import PopupDoMoKuai from './popup-do-mo-kuai'
import PopupDoForm from './popup-do-form'
import PopupDoZiDuan from './popup-do-zi-duan'
import PopupSetSpec from './popup-set-spec'
import PopupSetUnit from './popup-set-unit'
import PopupSetPrice from './popup-set-price'
import PopupBindSheBei from './popup-bind-she-bei'
import PopupSetSymbol from './popup-set-symbol'
import PopupSetOptions from './popup-set-options'
import PopupSetGongShi from './popup-set-gong-shi'
export default {
  components: {
    TabsMoKuai,
    PopupDoMoKuai,
    PopupDoForm,
    PopupDoZiDuan,
    PopupSetSpec,
    PopupSetUnit,
    PopupSetPrice,
    PopupBindSheBei,
    PopupSetSymbol,
    PopupSetOptions,
    PopupSetGongShi
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [String, Number],
      default: ''
    },
    bao_han: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false,
      timer: null,
      selfShow: false,
      selfData: this.$util.deepCopy(this.$constant.muBanShangPinDefaultData),
      requiredTitleObj: {
        原料: ['规格', '单位', '价格'],
        加工: ['设备'],
        零件: [],
        组装: [],
        商品: []
      },
      categoryTextureStr: '',
      categoryTextureData: {},
      formColumn: [
        {
          type: 'text',
          field: 'mu_ban_ming_cheng',
          title: '模板名称',
          width: '341px',
          required: true
        },
        {
          type: 'text',
          field: 'mu_ban_guan_jian_ci',
          title: '模板关键词',
          width: '341px',
          placeholder: this.$tool.useEnSymbolFenGe(','),
          titleMore: this.$tool.useEnSymbolFenGe(','),
          required: true
        },
        {
          type: 'upload_image',
          field: 'mu_ban_feng_mian',
          title: '模板封面',
          width: '341px',
          size: '28px',
          limit: 1,
          isDelete: true
        },
        {
          type: 'button',
          title: '规格',
          width: '341px',
          placeholder: '设置',
          icon: 'vxe-icon-setting',
          required: true,
          isError: true,
          hide: true,
          fnChange: () => {
            this.isShowPopupSetSpec = true
          }
        },
        {
          type: 'button',
          title: '单位',
          width: '341px',
          placeholder: '设置',
          icon: 'vxe-icon-setting',
          required: true,
          isError: true,
          hide: true,
          fnChange: () => {
            for (let i = 0; i < this.formColumn.length; i++) {
              if (this.formColumn[i].isError && this.formColumn[i].title === '规格') {
                this.$message.error(`请先设置${this.formColumn[i].title}`)
                return
              }
            }
            this.isShowPopupSetUnit = true
          }
        },
        {
          type: 'button',
          title: '价格',
          width: '341px',
          placeholder: '设置',
          icon: 'vxe-icon-setting',
          required: true,
          isError: true,
          hide: true,
          fnChange: () => {
            for (let i = 0; i < this.formColumn.length; i++) {
              if (
                this.formColumn[i].isError &&
                (this.formColumn[i].title === '规格' || this.formColumn[i].title === '单位')
              ) {
                this.$message.error(`请先设置${this.formColumn[i].title}`)
                return
              }
            }
            this.isShowPopupSetPrice = true
          }
        },
        {
          type: 'button',
          title: '设备',
          width: '1360px',
          placeholder: '绑定',
          icon: 'vxe-icon-link',
          hide: true,
          fnChange: () => {
            this.isShowPopupBindSheBei = true
          }
        }
      ],
      rules: {
        mu_ban_ming_cheng: [{ required: true, message: '请输入模板名称' }],
        mu_ban_guan_jian_ci: [{ required: true, message: '请输入模板关键词' }]
      },
      isShowPopupDoMoKuai: false,
      isShowPopupDoForm: false,
      isShowPopupDoZiDuan: false,
      isShowPopupSetSpec: false,
      isShowPopupSetUnit: false,
      isShowPopupSetPrice: false,
      isShowPopupBindSheBei: false,
      isShowPopupSetSymbol: false,
      isShowPopupSetOptions: false,
      isShowPopupSetGongShi: false,
      activeNavIndex: 0,
      activeMoKuaiIndex: '',
      activeFormIndex: '',
      activeZiDuanIndex: '',
      muBanChooseList: [],
      muBanChooseId: null
    }
  },
  computed: {
    // 选项卡菜单列表
    tabNavList() {
      let result = []
      if (this.selfData.custom_mo_kuai_list.length) {
        result = this.selfData.custom_mo_kuai_list.map((item, index) => {
          return {
            key: item.name,
            val: JSON.stringify(index)
          }
        })
      }
      return result
    },
    // 类目选中字符串
    categoryActiveStr() {
      let result = ''
      if (this.detailId) {
        result = this.selfData.lei_mu_name
      } else {
        let listName = []
        listName = this.categoryTextureData.category_list.map((item) => {
          return item.name
        }) // 类目
        if (this.categoryTextureData.texture_data.key) {
          listName.push(this.categoryTextureData.texture_data.key) // 材质
        }
        result = listName.join('/')
      }

      return result // 类目材质拼接成字符串
    },
    // 类目类型
    activeCategoryType() {
      let result = ''
      if (this.detailId) {
        result = this.selfData.lei_mu_lei_xing
      } else {
        if (this.categoryTextureData && this.categoryTextureData.category_list) {
          let len = this.categoryTextureData.category_list.length
          if (len) result = this.categoryTextureData.category_list[len - 1].lei_mu_lei_xing
        }
      }
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    selfData: {
      handler(val) {
        this.formColumn.forEach((item) => {
          if (item.title.includes('设备')) {
            let len = val.she_bei_list.length
            item.isError = !len
            item.placeholder = `绑定(${len})`
          }
          if (item.title.includes('规格')) item.isError = !val.gui_ge_list.length
          if (item.title.includes('单位')) item.isError = !val.dan_wei_zu_list.length
          if (item.title.includes('价格'))
            item.isError = !(val.mo_ren_dan_wei_zu && val.ji_chu_jia_ge)
        })
      },
      deep: true,
      immediate: true
    },
    'selfData.dan_wei_zu_list': {
      handler(val) {
        let result = []

        val.forEach((itemSt) => {
          itemSt.dan_wei_list.forEach((itemNd) => {
            // 存储默认单位
            if (itemNd.is_mo_ren_dan_wei) {
              this.selfData.mo_ren_dan_wei_zu = `${itemNd.dan_wei_name},${itemSt.dan_wei_zu_name}`
            }

            // 下拉单位数据
            result.push({
              key: `${itemNd.dan_wei_name}`,
              val: `${itemNd.dan_wei_name},${itemSt.dan_wei_zu_name}`
            })
          })
        })
        this.selfData.custom_mo_kuai_list[0].list[0].list.forEach((item) => {
          if (item.name === '单位') {
            item.set_options = result
            return
          }
        })
      },
      deep: true,
      immediate: true
    },
    muBanChooseId(val) {
      if (val) {
        this.initSelfData(val, true)
        this.muBanChooseId = null
      }
    },
    // 类目材质数据
    categoryTextureData: {
      handler(val) {
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.selfData.lei_mu_name = this.categoryActiveStr
          this.selfData.lei_mu_lei_xing = this.activeCategoryType
          if (val.category_list && val.category_list.length) {
            this.selfData.lei_mu_data = this.$util.deepCopy(val)
          }
          if (!this.detailId) this.selfData.mi_du_shi_li = val.texture_data.val
          this.timer = null
        }, 500)
      },
      deep: true,
      immediate: true
    },
    // 类目类型
    activeCategoryType(val) {
      if (val) {
        this.getMuBanChooseListData(val)
        this.initPriceField(val)
        this.initFormColumn(val)
      }
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.detailId) {
      this.initSelfData(this.detailId, false)
    } else {
      this.loaded = true
    }
  },
  methods: {
    // 一键引用
    oneKeyLoadData() {
      this.selfData.gui_ge_list = ['外径', '厚度', '长度']
      this.selfData.dan_wei_zu_list = this.$util.deepCopy(
        this.$constant.shangPinMuBanUnitListImport
      )
      this.selfData.ji_chu_jia_ge = 14
    },
    // 获取模板选择列表数据
    getMuBanChooseListData(type) {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          bao_han: [type],
          sortData: {
            id: 'desc'
          }
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.muBanChooseList = res.data.page.list.map((item) => {
              return {
                key: item.mu_ban_ming_cheng,
                val: item.id
              }
            })
          }
        })
        .catch(() => {})
    },
    // 初始化价格字段
    initPriceField(type) {
      this.selfData.custom_mo_kuai_list[0].list[0].list.forEach((item) => {
        if (item.name === '单价') {
          if (type === '商品') {
            item.is_edit = true
            item.lei_xing_str = '输入框(数字)'
            item.lei_xing_id = 2
            item.set_gong_shi = []
          } else {
            item.is_edit = false
            item.lei_xing_str = '公式'
            item.lei_xing_id = 11
            item.set_gong_shi = ['材料单价', '+', '加工单价']
          }
        }
      })
    },
    // 初始化表单
    initFormColumn(type) {
      this.formColumn.forEach((itemSt) => {
        if (this.requiredTitleObj['原料'].includes(itemSt.title)) itemSt.hide = type !== '原料'
        if (this.requiredTitleObj['加工'].includes(itemSt.title)) itemSt.hide = type !== '加工'
      })
    },
    // 初始化数据
    async initSelfData(id, loaded) {
      this.loaded = loaded
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/muBan/detail',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.data
          if (!this.detailId) {
            let mu_ban_ming_cheng = this.selfData.mu_ban_ming_cheng
            let mu_ban_guan_jian_ci = this.selfData.mu_ban_guan_jian_ci
            result.id = ''
            result.lei_mu_name = this.selfData.lei_mu_name
            result.lei_mu_data = this.$util.deepCopy(this.selfData.lei_mu_data)
            if (mu_ban_ming_cheng) result.mu_ban_ming_cheng = mu_ban_ming_cheng
            if (mu_ban_guan_jian_ci) result.mu_ban_guan_jian_ci = mu_ban_guan_jian_ci
          } else {
            this.categoryTextureStr = result.lei_mu_name
          }
          this.selfData = result
        }
      })
      this.loaded = true
    },
    isShowField(field) {
      let list = ['商品关键词', '商品编码', '商品封面']
      let result = list.every((item) => item !== field.name)
      return result && field.is_show
    },
    // 设置价格-成功
    setPriceSuccess(val) {
      this.selfData = this.$util.deepCopy(val[0])
    },
    // 新增样式问号
    addClassQuestion(item) {
      let result = []
      if (item.is_edit) {
        if (item.lei_xing_id === 4) {
          result.push(item.set_symbol ? 'question-success' : 'question-error')
        }
        if (item.lei_xing_id === 8) {
          result.push(item.set_options.length ? 'question-success' : 'question-error')
        }
        if (item.lei_xing_id === 11) {
          result.push(item.set_gong_shi.length ? 'question-success' : 'question-error')
        }
      }
      return result
    },
    // 模块-增改
    moduleDoOpen(index) {
      let isEdit = typeof index === 'number'
      if (isEdit) {
        this.activeMoKuaiIndex = index
      } else {
        this.activeMoKuaiIndex = ''
      }
      this.isShowPopupDoMoKuai = true
    },
    // 模块-删除
    moduleDelete(index) {
      this.activeNavIndex = 0
      this.activeMoKuaiIndex = ''
      this.selfData.custom_mo_kuai_list.splice(index, 1)
    },
    // 模块-增改成功
    moduleDoSuccess(data) {
      if (this.activeMoKuaiIndex === '') {
        this.selfData.custom_mo_kuai_list.push(data)
        this.activeNavIndex = this.selfData.custom_mo_kuai_list.length - 1
      } else {
        this.selfData.custom_mo_kuai_list.splice(this.activeMoKuaiIndex, 1, data)
      }
    },
    // 表单-增改
    formDoOpen(index) {
      let isEdit = typeof index === 'number'
      if (isEdit) {
        this.activeFormIndex = index
      } else {
        this.activeFormIndex = ''
      }
      this.isShowPopupDoForm = true
    },
    // 表单-删除
    formDelete(index) {
      this.selfData.custom_mo_kuai_list[this.activeNavIndex].list.splice(index, 1)
    },
    // 表单-增改成功
    formDoSuccess(data) {
      if (this.activeFormIndex === '') {
        this.selfData.custom_mo_kuai_list[this.activeNavIndex].list.push(data)
      } else {
        this.selfData.custom_mo_kuai_list[this.activeNavIndex].list.splice(
          this.activeFormIndex,
          1,
          data
        )
      }
    },
    // 字段-增改打开
    ziDuanDoOpen(index) {
      this.activeFormIndex = index
      this.isShowPopupDoZiDuan = true
    },
    // 字段-增改成功
    ziDuanDoSuccess(data) {
      this.selfData.custom_mo_kuai_list[this.activeNavIndex].list[this.activeFormIndex].list = data
    },
    // 字段-设置
    ziDuanSet(indexNd, indexRd) {
      this.activeFormIndex = indexNd
      this.activeZiDuanIndex = indexRd
      let item =
        this.selfData.custom_mo_kuai_list[this.activeNavIndex].list[this.activeFormIndex].list[
          this.activeZiDuanIndex
        ]
      if (!item.is_set) return
      if (item.lei_xing_id === 4) this.isShowPopupSetSymbol = true
      if (item.lei_xing_id === 8) this.isShowPopupSetOptions = true
      if (item.lei_xing_id === 11) this.isShowPopupSetGongShi = true
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          let len = this.formColumn.length
          for (let i = 0; i < len; i++) {
            let item = this.formColumn[i]
            if (
              this.requiredTitleObj[this.activeCategoryType].includes(item.title) &&
              item.isError
            ) {
              this.$message.error(`请设置${item.title}`)
              return
            }
          }

          this.$api({
            method: 'post',
            url: '/admin/gcvip/muBan/saveOrUpdate',
            data: this.selfData
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.popupCancel()
              this.$emit('success')
              this.$message.success('保存成功')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .mu-ban-category {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
  }
  .module-box {
    margin-right: 10px;
    border: 1px solid @colorGrayD;
    .module-cont {
      min-height: 276px;
      max-height: 460px;
      padding: 10px;
      overflow: auto;
      .scroll-bar();
      .form-list {
        font-size: 12px;
        color: @colorGrayDeep;
        .form-item {
          & ~ .form-item {
            margin-top: 10px;
          }
          .form-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid @colorGrayD;
            margin-bottom: -1px;
            .form-left {
              display: flex;
              align-items: center;
              .form-name {
                min-width: 59px;
                padding: 5px;
                margin-right: 5px;
                line-height: 18px;
                text-align: center;
                font-weight: bold;
                color: @colorGray;
                background: @colorGrayE;
                border: 1px solid @colorGrayD;
                border-bottom: none;
                border-radius: 3px 3px 0 0;
              }
            }
          }
          .zi-duan-list {
            display: flex;
            min-width: 928px;
            min-height: 28px;
            border: 1px solid @colorGrayD;
            .zi-duan-group {
              margin: -1px;
              .zi-duan-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: nowrap;
                min-width: 155px;
                height: 18px;
                padding: 5px;
                background: #f8f8f9;
                border: 1px solid @colorGrayD;
                & ~ .zi-duan-item {
                  margin-top: -1px;
                  background: @colorWhite;
                }
                &.is-set {
                  cursor: pointer;
                }
                .zi-duan-name {
                  width: 100%;
                  display: flex;
                  align-items: center;
                  white-space: nowrap;

                  .question-success {
                    color: @colorBlue;
                    .question-box {
                      .question-cont {
                        color: @colorWhite;
                        background: @colorBlue;
                      }
                    }
                  }
                  .question-error {
                    color: @colorRed;
                    .question-box {
                      .question-cont {
                        color: @colorWhite;
                        background: @colorRed;
                      }
                    }
                  }
                  .question-box {
                    position: relative;
                    margin-left: 3px;
                    &.vxe-icon-question-circle {
                      font-size: 16px;
                    }
                    &:hover {
                      .question-cont {
                        display: inline-block;
                      }
                    }
                    .question-cont {
                      display: none;
                      position: absolute;
                      bottom: -3px;
                      left: 0;
                      padding: 5px 8px;
                      font-size: 12px;
                      line-height: 1;
                      color: @colorWhite;
                      background: @colorGrayLight;
                      border-radius: 4px;
                      z-index: 9;
                    }
                  }
                  .vxe-icon-setting {
                    font-size: 16px;
                  }
                }
                i {
                  display: inline-block;
                }
              }
            }
          }
        }
        .form-add {
          padding: 0 5px;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
